import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useQuery } = ReactQueryV5;
import { PromoCode } from "core/types";
import { get } from "../services/httpClient";

export const useUserPromoCodes = (userId?: number) =>
  useQuery({
    queryKey: ["userPromoCodes", userId],
    queryFn: () =>
      get<{ data: PromoCode[] }>(`users/${userId}/individual-keys`).then(
        (r) => r.data,
      ),
    enabled: !!userId,
  });
